<template>
  <div>
    <div class="page-header"><h2><span class="breadcrumb-level">数据统计</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">分析报告</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">用户分析</span></h2></div>
    <el-row :gutter="20" class="metrics-row">
      <el-col :span="8"><el-card shadow="hover" class="metric-card">
        <div class="metric-value">{{ data.total_users }}</div>
        <div class="metric-label">总用户数</div>
      </el-card></el-col>
      <el-col :span="8"><el-card shadow="hover" class="metric-card">
        <div class="metric-value">{{ data.today_new }}</div>
        <div class="metric-label">今日新增</div>
      </el-card></el-col>
      <el-col :span="8"><el-card shadow="hover" class="metric-card">
        <div class="metric-value">{{ data.weekly_new }}</div>
        <div class="metric-label">本周新增</div>
      </el-card></el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-card shadow="hover"><template #header><span style="font-weight:600">注册趋势</span><span style="float:right;font-size:12px;color:#909399">近30天</span></template>
          <div class="bar-chart-wrap"><div class="bar-chart" style="height:220px">
            <div class="bar-item" v-for="(item, i) in data.trends" :key="i">
              <div class="bar-bar" :style="{ height: barH(item.count) + '%' }"><span class="bar-num" v-if="item.count>0">{{ item.count }}</span></div>
              <div class="bar-label">{{ item.date.slice(5) }}</div>
            </div>
          </div></div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover"><template #header><span style="font-weight:600">会员等级</span></template>
          <div class="pie-list">
            <div class="pie-item" v-for="s in memberLevelList" :key="s.label">
              <span class="pie-dot" :style="{ background: s.color }"></span>
              <span class="pie-label">{{ s.label }}</span>
              <span class="pie-val">{{ s.count }}</span>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover"><template #header><span style="font-weight:600">性别分布</span></template>
          <div class="pie-list">
            <div class="pie-item" v-for="s in genderList" :key="s.label">
              <span class="pie-dot" :style="{ background: s.color }"></span>
              <span class="pie-label">{{ s.label }}</span>
              <span class="pie-val">{{ s.count }}</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import * as api from '../../api/statistics';

const raw = ref({});
const data = computed(() => raw.value || {});
const colors = ['#409eff', '#67c23a', '#e6a23c', '#f56c6c', '#9b59b6', '#1abc9c', '#e67e22', '#95a5a6'];
const memberLevelList = computed(() => (raw.value.by_member_level || []).map((s, i) => ({ ...s, color: colors[i % colors.length] })));
const genderList = computed(() => (raw.value.by_gender || []).map((s, i) => ({ ...s, color: colors[i % colors.length] })));

const barH = (count) => { const arr = raw.value.trends || []; const max = Math.max(...arr.map(t => t.count || 0), 1); return Math.max(4, (count / max) * 100); };

onMounted(async () => { try { const r = await api.getUserStats(); raw.value = r.data || {}; } catch {} });
</script>

<style scoped>
.metrics-row { margin-bottom: 24px; }
.metric-card { text-align: center; padding: 10px 0; }
.metric-value { font-size: 36px; font-weight: 700; color: #409eff; line-height: 1.2; }
.metric-label { font-size: 14px; color: #606266; margin-top: 6px; }
.bar-chart-wrap { padding: 10px 0; overflow-x: auto; }
.bar-chart { display: flex; align-items: flex-end; justify-content: flex-start; gap: 2px; min-width: 100%; }
.bar-item { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: flex-end; height: 100%; min-width: 20px; }
.bar-bar { width: 100%; max-width: 28px; background: linear-gradient(180deg, #409eff, #79bbff); border-radius: 4px 4px 2px 2px; min-height: 6px; display: flex; align-items: flex-start; justify-content: center; padding-top: 3px; transition: height 0.5s; }
.bar-num { font-size: 10px; color: #fff; font-weight: 600; }
.bar-label { font-size: 10px; color: #909399; margin-top: 4px; white-space: nowrap; }
.pie-list { padding: 6px 0; }
.pie-item { display: flex; align-items: center; padding: 10px 0; border-bottom: 1px solid #f5f5f5; gap: 8px; }
.pie-item:last-child { border-bottom: none; }
.pie-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.pie-label { flex: 1; font-size: 13px; color: #606266; }
.pie-val { font-size: 16px; font-weight: 600; color: #303133; }
</style>
